import * as React from 'react';

export default {
  Insights: React.lazy(
    () =>
      import(
        /* webpackChunkName: "insights" */
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        './index'
      ),
  ),
};
